module.exports = __webpack_public_path__ + "static/media/Promos_30_.5ccba171.png";